
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 3.75c3.62-.056 7.25 2.445 9.483 4.9l.002.002a2.011 2.011 0 010 2.692l-.002.002C17.3 13.748 13.68 16.306 10 16.248c-3.68.057-7.3-2.5-9.48-4.902l-.002-.002a2.01 2.01 0 010-2.692L.52 8.65C2.75 6.195 6.38 3.694 10 3.75zM1.446 9.49a.76.76 0 000 1.016c2.09 2.303 5.395 4.545 8.544 4.492h.02c3.15.053 6.454-2.19 8.547-4.492a.76.76 0 000-1.016C16.419 7.14 13.105 4.948 10.01 5h-.02c-3.094-.052-6.408 2.14-8.544 4.49z","fill":"#5C6970"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.957 7.69A2.5 2.5 0 1012.5 10a2.5 2.5 0 00-1.543-2.31zM10 6.248A3.749 3.749 0 0113.75 10M10 6.249A3.75 3.75 0 1013.75 10","fill":"#5C6970"}})])
          )
        }
      }
    